export default __webpack_public_path__ + "static/media/BackImage.e20bd65d.png";